import { proxy } from "valtio";

const state = proxy({ unit: "celsius" });

export default state;

// https://www.youtube.com/watch?v=p8l9LiWyQJs
